export const TRAINER_META = [
  {
    slug: "english-sounds",
    title: "Английские звуки",
    goal: "Услышать и узнать 44 английских звука, связать их с буквами и словами.",
    age: "7–9 лет",
    level: "Pre-A1",
    duration: "8–12 мин",
    lessons: 60,
    oneTime: 249000,
    monthly: 59000,
  },
  {
    slug: "word-in-frame",
    title: "Слово в кадре",
    goal: "Понять 48 слов и собрать сцену по английской реплике.",
    age: "7–9 лет",
    level: "Pre-A1 / A1",
    duration: "8–12 мин",
    lessons: 11,
    oneTime: 199000,
    monthly: 49000,
  },
  {
    slug: "phrase-director",
    title: "Фразовый режиссёр",
    goal: "Собрать короткие английские фразы и снять мини-историю.",
    age: "7–9 лет",
    level: "Pre-A1 / A1",
    duration: "5–15 мин",
    lessons: 10,
    oneTime: 199000,
    monthly: 49000,
  },
] as const;

export const CATALOG_ONE_TIME = 499000;
export const CATALOG_MONTHLY = 99000;

export const ANNA = {
  slug: "anna-clever",
  name: "Анна — демо-репетитор Clever",
  bio: "Короткие самостоятельные занятия по звукам, грамматике и пониманию историй. Родители видят понятный прогресс без школьных оценок.",
  specialization: "английский для детей 7–12 лет",
};
